<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.back()"
        >
          <v-icon>mdi-arrow-left</v-icon></v-btn
        >
      </template>
      <span>{{ $t("inspectionList.goBack") }}</span>
    </v-tooltip>
    <v-tabs
      class="v-tabs--pill primary white--text"
      hide-slider
      active-class="white primary--text"
      v-model="tab"
      show-arrows
      dark
      background-color="transparent"
      centered
      touchless
      icons-and-text
    >
      <v-tab
        touchless
        class="white--text font-weight-medium"
        v-for="item in items"
        :key="item"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
    <v-tabs-items touchless v-model="tab" class="pt-12 transparent">
      <v-tab-item>
        <base-material-card
          icon="mdi-clipboard-text-outline"
          color="primary"
          inline
          class="px-5 py-3 my-12"
        >
          <v-btn fixed bottom left fab @click="$router.back()" color="primary">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <template v-slot:after-heading>
            <div class="title text-no-wrap font-weight-bold">
              {{ $t("worksProfile.projectProfile") }}
            </div>
          </template>
          <v-row align="center" justify="center">
            <v-col cols="12" md="6" align="center" justify="center">
              <ListOfWorkProfile
                :work-profile="workProfile"
                :total-cost="totalCost"
              />
              <v-progress-linear
                class="my-12"
                dark
                v-model="progress"
                height="25"
              >
                <strong>{{ Math.ceil(progress) }}%</strong>
              </v-progress-linear>
            </v-col>

            <v-col cols="12" lg="6">
              <base-material-card
                id="multiple-bar"
                color="success"
                icon="mdi-poll-box"
                class="px-4 py-3"
              >
                <template v-slot:after-heading>
                  <div class="display-1 mt-2 font-weight-light">
                    {{ $t("worksProfile.multipleBarsChart") }}
                  </div>
                </template>
                <apexchart
                  v-if="!loading"
                  type="bar"
                  :options="options"
                  :series="series"
                ></apexchart>
              </base-material-card>
            </v-col>
          </v-row>
        </base-material-card>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          show-select
          :headers="headers"
          :items="workProfile.inventory"
          sort-by="name"
          v-model="workProfile.selected"
          class="elevation-0 my-12"
          :footer-props="{
            itemsPerPageText: $t('repairList.itemsPerPage'),
            itemsPerPageAllText: $t('repairList.itemsPerPageAllText')
          }"
        >
          <template v-slot:top>
            <v-toolbar flat color="transparent">
              <!--       <span class="title font-weight-bold">Inventario</span> -->
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    absolute
                    top
                    right
                    color="primary"
                    dark
                    class=""
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.name"
                            :label="$t('worksProfile.name')"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-select
                            :items="typeItems"
                            item-text="text"
                            item-value="value"
                            v-model="editedItem.type"
                            :label="$t('worksProfile.type')"
                          ></v-select>
                        </v-col>

                        <v-col cols="12">
                          <v-select
                            :items="[
                              'Desmontaje',
                              'Fabricación',
                              'Montaje',
                              'Reemplazo'
                            ]"
                            v-model="editedItem.subtype"
                            :label="$t('worksProfile.subtype')"
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            type="number"
                            step="0.01"
                            v-model="editedItem.partialCost"
                            :label="$t('worksProfile.partialCost')"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            type="number"
                            step="1"
                            v-model="editedItem.quanty"
                            :label="$t('worksProfile.quanty')"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      {{ $t("worksProfile.cancel") }}
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      {{ $t("worksProfile.save") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="headline"
                    >Are you sure you want to delete this item?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                      >Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >OK
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{ item.date | formatDate(user.language) | capitalize }}
          </template>
          <template v-slot:[`item.type`]="{ item }">
            {{ $t(`worksProfile.${item.type}`) }}
          </template>
          <template v-slot:[`item.subtype`]="{ item }">
            {{ $t(`worksProfile.${item.subtype}`) }}
          </template>
          <template v-slot:[`item.subtotal`]="{ item }">
            {{ parseFloat(item.partialCost * item.quanty).toFixed(2) }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import ListOfWorkProfile from "@/views/WorkProfile/ListOfWorkProfile";

export default {
  components: { ListOfWorkProfile },
  data() {
    return {
      tab: null,
      loading: false,
      selected: [],
      items: ["PERFIL", "ITEMS"],
      dialog: false,
      dialogDelete: false,
      headers: [
        { text: this.$t("worksProfile.name"), value: "name" },
        { text: this.$t("worksProfile.date"), value: "date" },
        { text: this.$t("worksProfile.quanty"), value: "quanty" },
        { text: this.$t("worksProfile.type"), value: "type" },
        { text: this.$t("worksProfile.subtype"), value: "subtype" },
        { text: this.$t("worksProfile.partialCost"), value: "partialCost" },
        { text: this.$t("worksProfile.subtotal"), value: "subtotal" },
        { text: "", value: "actions", sortable: false }
      ],

      editedIndex: -1,
      editedItem: {
        name: "",
        date: "",
        type: "",
        subtype: "",
        partialCost: 0,
        quanty: 0
      },
      defaultItem: {
        name: "",
        date: "",
        type: "",
        subtype: "",
        partialCost: 0,
        quanty: 0
      },
      typeItems: [
        { text: this.$t("worksProfile.personal"), value: "personal" },
        { text: this.$t("worksProfile.structures"), value: "structures" },
        { text: this.$t("worksProfile.pipes"), value: "pipes" },
        { text: this.$t("worksProfile.surfaces"), value: "surfaces" }
      ],
      subtypeItems: [
        { text: this.$t("worksProfile.disassembly"), value: "disassembly" },
        { text: this.$t("worksProfile.manufacturing"), value: "manufacturing" },
        { text: this.$t("worksProfile.assembly"), value: "assembly" },
        { text: this.$t("worksProfile.replacement"), value: "replacement" }
      ]
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("works", ["workProfile"]),
    progress() {
      if (
        this.workProfile?.selected &&
        this.workProfile.inventory?.length > 0
      ) {
        return (
          (this.workProfile?.selected?.length /
            this.workProfile.inventory?.length) *
          100
        );
      } else {
        return 0;
      }
    },
    options() {
      return {
        chart: {
          height: 400,
          background: this.$vuetify.theme.dark ? "#1E1E1E" : "#FFFFFF",
          type: "bar"
        },
        theme: {
          mode: this.$vuetify.theme.dark ? "dark" : "light"
        },
        colors: ["#2E93fA", "#66DA26", "#546E7A", "#E91E63", "#FF9800"],
        plotOptions: {
          bar: {
            columnWidth: "35%"
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        yaxis: {
          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            style: {
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-label"
            },
            offsetX: 0,
            offsetY: 0,
            rotate: 0
          }
        },
        xaxis: {
          categories: this.workProfile.inventory?.map(item => item.name),
          labels: {
            style: {
              fontSize: "12px"
            }
          }
        }
      };
    },
    series() {
      return [
        {
          name: "Costo Parcial ($)",
          data: this.workProfile.inventory?.map(item =>
            parseInt(item.partialCost * item.quanty).toFixed(2)
          )
        }
      ];
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("worksProfile.newItem")
        : this.$t("worksProfile.editItem");
    },
    totalCost() {
      let initialValue = 0;
      if (this.workProfile?.inventory?.length > 0) {
        return (
          "$ " +
          this.workProfile.inventory.reduce(function(total, currentValue) {
            return total + currentValue.quanty * currentValue.partialCost;
          }, initialValue)
        );
      } else {
        return `$ 0`;
      }
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    "workProfile.selected"() {
      this.itemSelected();
    }
  },
  async created() {
    await this.$store.dispatch("works/bindAWork", this.$route.params.id);
  },
  methods: {
    async itemSelected() {
      let payload = {
        db: `works`,
        data: { selected: this.workProfile.selected },
        doc: this.workProfile.id
      };

      await this.$store.dispatch("updateDocument", payload);

      this.close();
    },

    editItem(item) {
      this.editedIndex = this.workProfile.inventory.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.workProfile.inventory.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.loading = true;
      this.workProfile.inventory.splice(this.editedIndex, 1);
      let payload = {
        db: `works`,
        data: {
          inventory: this.workProfile.inventory
        },
        doc: this.workProfile.id
      };
      try {
        await this.$store.dispatch("updateDocument", payload);
        this.$dialog.notify.success(
          "Your new stock has been delete successfully",
          {
            position: "top-right",
            timeout: 5000
          }
        );
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      }

      this.loading = false;
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.loading = true;
      if (this.editedIndex > -1) {
        Object.assign(
          this.workProfile.inventory[this.editedIndex],
          this.editedItem
        );
      } else {
        const uid = function() {
          return (
            Date.now().toString(36) +
            Math.random()
              .toString(36)
              .substr(2)
          );
        };
        this.editedItem.date = new Date();
        this.editedItem.id = uid();
        this.workProfile.inventory.push(this.editedItem);
      }

      let payload = {
        db: `works`,
        data: {
          inventory: this.workProfile.inventory
        },
        doc: this.workProfile.id
      };
      try {
        await this.$store.dispatch("updateDocument", payload);
        this.$dialog.notify.success(
          "Your new stock has been updated successfully",
          {
            position: "top-right",
            timeout: 5000
          }
        );
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      }

      this.loading = false;
      this.close();
    }
  }
};
</script>
